export const SIGN_IN_ROUTE = '/signin';

export const isSubscriberOnlyContent = (content) =>
  Boolean(content?.is_locked || content?.is_exclusive || content?.premium_required);

export const buildSubscriberSignInPath = (redirectTo = '') => {
  if (!redirectTo) {
    return SIGN_IN_ROUTE;
  }

  const searchParams = new URLSearchParams({ redirect: redirectTo });
  return `${SIGN_IN_ROUTE}?${searchParams.toString()}`;
};
